import { createContext, useContext, useMemo } from 'react';
import { FeatureFlags } from '../constants/FeatureFlags';
import { usePublicFeatureFlags } from '../hooks/usePublicFeatureFlags';
import { jsx as _jsx } from "react/jsx-runtime";
const DEFAULT_VALUE = {
  loading: true,
  isUngatedForSeats: false,
  isHubSpotOnCredits: false,
  hasMismatchedProductsAndPopData: false,
  mismatchedProductsAndPopDataMetrics: undefined
};

/**
 * Public-only derived cohort info: a tiny subset of the in-app provider's output,
 * resolved purely from the public feature-flags RPC. No POP / ProductDetails fan-out.
 *
 * Copied + simplified from pricing-pages-ui/context/DerivedCohortInfoContext —
 * do not import from there. The in-app provider is not ported (the public app
 * doesn't need it). Feature flags are read via `usePublicFeatureFlags` so all
 * public consumers share one cached RPC and one place to evolve the contract.
 */
export const DerivedCohortInfoContext = /*#__PURE__*/createContext(DEFAULT_VALUE);
export const PublicDerivedCohortInfoProvider = ({
  children
}) => {
  const {
    featureFlags,
    loading
  } = usePublicFeatureFlags();
  const value = useMemo(() => ({
    loading,
    isUngatedForSeats: featureFlags.includes(FeatureFlags.SEATS),
    isHubSpotOnCredits: featureFlags.includes(FeatureFlags.HUBSPOT_ON_CREDITS),
    hasMismatchedProductsAndPopData: false,
    mismatchedProductsAndPopDataMetrics: undefined
  }), [featureFlags, loading]);
  return /*#__PURE__*/_jsx(DerivedCohortInfoContext.Provider, {
    value: value,
    children: children
  });
};
export const useDerivedCohortInfoContext = () => useContext(DerivedCohortInfoContext);